// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qy_a bie_sw bie_kx bie_ky","PostDetailRight__brandDaysPosts":"qy_b bie_sw bie_kx bie_ky"};